
/*
	File generated by Typewriter automatically.
	Changes will be overwritten!
 */

import { User } from './user.model';

export class Auth extends User { 
}

